var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94452 2.69998L3.78702 9.21748C3.55452 9.46498 3.32952 9.95248 3.28452 10.29L3.00702 12.72C2.90952 13.5975 3.53952 14.1975 4.40952 14.0475L6.82452 13.635C7.16202 13.575 7.63452 13.3275 7.86702 13.0725L14.0245 6.55498C15.0895 5.42998 15.5695 4.14748 13.912 2.57998C12.262 1.02748 11.0095 1.57498 9.94452 2.69998Z",
    stroke: "#EBEDFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91797 3.78748C9.24047 5.85748 10.9205 7.43998 13.0055 7.64997",
    stroke: "#EBEDFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.5H15.75",
    stroke: "#EBEDFA",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDisabled);
export default __webpack_public_path__ + "static/media/EditDisabled.07394c276c2f14e6f6756e519c9e144c.svg";
export { ForwardRef as ReactComponent };